import React from 'react';
import * as _ from 'lodash';
import * as pages from './pageComponents';

import LocalStorageService from '../services/utilities/LocalStorageService';
import SessionStorageService from '../services/utilities/SessionStorageService';

import splitViewManager from '../utilities/splitViewManager';
import urlParamManger from '../utilities/urlParamManager';
import EventManager, { EventType } from '../utilities/EventManager';
import {
  isPartnerCompanyRoleId,
  isTargetRoleId,
} from '../utilities/roleUtility';
import { isNullOrEmpty } from '../utilities/stringUtil';
import { USER_ROLES } from '../utilities/constants';
import { PermissionConsumer } from '../utilities/PermissionContext';
import { FieldBulletinBoardMenuList } from './FieldBulletinBoardMenuList';

export default class EnterFuncNavi extends React.Component {
  constructor(props) {
    super(props);

    this.settingPages = Object.keys(pages.setting); //設定系画面
    this.singlePages = [
      'FieldTree',
      'Dashboard',
      'SafetyDiaries',
      'ConstructionPlacementPlace',
      'Layout',
    ]; //分割しない画面
    this.singlePages = _.concat(this.singlePages, this.settingPages);
    this.pages = _.merge(pages, pages.setting);
    this.naviRef = null;

    this.state = {
      multiview: true, //マルチビューの状態
      railnavi: sessionStorage.getItem('is_conference') ? true : false, //メニューの状態
      page: '', //ページコンポーネント名
      spotFlg: SessionStorageService.getSpotFlg(),
    };

    /**
     * 分割画面のパラメータ
     */
    urlParamManger.setDelegate(urlparam => {
      if (
        //現在と違うページの場合に更新
        urlparam[this.props.vw - 1] &&
        this.state.page.split(':')[0] !=
          urlparam[this.props.vw - 1].split(':')[0]
      ) {
        this.setState({ page: urlparam[this.props.vw - 1] });
        this.loadPage(urlparam[this.props.vw - 1]);
        EventManager.trigger(EventType.LAYOUT_UPDATE, {});
      }
    });
  }

  componentDidMount() {
    EventManager.addEventListener(EventType.CONFERENCE_MODE, conference => {
      this.setState({
        railnavi: !conference,
        spotFlg: SessionStorageService.getSpotFlg(),
      });
      EventManager.trigger(EventType.LAYOUT_UPDATE, {});
    });
    EventManager.addEventListener(EventType.LAYOUT_UPDATE, () => {
      this.setState({ spotFlg: SessionStorageService.getSpotFlg() });
    });
  }

  /**
   * サイドメニューの開閉
   * @param {boolean} b
   */
  naviStatus(b) {
    this.setState({ railnavi: b });
    EventManager.trigger(EventType.LAYOUT_UPDATE, {});
  }

  /**
   * ページのロード
   * @param { string } page
   */
  loadPage(page) {
    if (isNullOrEmpty(page) || page === this.state.page.split(':')[0]) {
      return;
    }

    let pageparam = page.split(':');

    //シングルページの場合 splitViewManagerに通知
    const regexp = new RegExp(`^(${this.singlePages.join('|')}).*`, 'g');
    if (pageparam[0].split(':')[0].match(regexp) ? true : false) {
      splitViewManager.forceSingleViewUpdate();
    }

    //ページをコンポーネントをロード
    const _settingPage = _.filter(this.settingPages, settingPage => {
      return settingPage == pageparam[0];
    });
    if (_settingPage.length) {
      this.props.loadSettingPage(this.pages[pageparam[0]], pageparam);
    } else {
      this.props.loadPage(this.pages[pageparam[0]], pageparam);
    }

    if (pageparam.length === 1 && this.state.page !== page) {
      urlParamManger.setPage(page, this.props.vw);
      this.setState({ page });
      setTimeout(() => {
        EventManager.trigger(EventType.LAYOUT_UPDATE, {});
      }, 1);
    }
  }

  //1画面判定正規表現
  regexp() {
    return new RegExp(`^(${this.singlePages.join('|')}).*`, 'g');
  }

  // 機能一覧を動作可能状態にする
  enableNavi() {
    if (!this.naviRef) {
      return;
    }
    this.naviRef.style.pointerEvents = 'auto';
    this.naviRef.style.opacity = '1';
    this.naviRef.style.cursor = 'pointer';
  }

  // 機能一覧を動作不可能状態にする
  disableNavi() {
    if (!this.naviRef) {
      return;
    }
    this.naviRef.style.pointerEvents = 'none';
    this.naviRef.style.opacity = '.6';
    this.naviRef.style.cursor = 'inherit';
  }

  render() {
    const railside = classname => {
      return this.state.railnavi ? `${classname} show` : classname;
    };

    /* eslint-disable no-unused-vars */

    const multiview = classname => {
      return this.state.multiview ? `${classname} selected` : classname;
    };
    const singleview = classname => {
      return !this.state.multiview ? `${classname} selected` : classname;
    };
    /* eslint-enable no-unused-vars */

    const itemSelected = page => {
      if (
        _.size(
          _.filter(this.settingPages, p => {
            return p === this.state.page.split(':')[0];
          })
        ) &&
        page === 'settingPage'
      ) {
        return 'line-list line-list--list select'; //各種設定
      }

      return (
        page === this.state.page.split(':')[0] 
        || (
        page === 'FieldSettings'
        && _.find(
          ['InOutFieldAreas', 'InOutFieldAreaNew', 'InOutFieldAreaEdit'], 
          (str) => str === this.state.page.split(':')[0]
        )
      ))
        ? 'line-list line-list--list select'
        : 'line-list line-list--list';
    };

    return (
      <PermissionConsumer>
        {({ userHasNyutaiPermission }) => {
          // rails.jsxのPermissionProviderから受け取る
          if (SessionStorageService.getFieldId() && userHasNyutaiPermission) {
            this.enableNavi();
          } else {
            this.disableNavi();
          }
          return (
            <div
              ref={e => {
                this.naviRef = e;
              }}
              id={`func-navi--item${this.props.vw}`}
              className={railside('rail__side')}
            >
              <div className='rail__navi'>
                <div
                  id='func-navi--item1-btn-open'
                  className='btn-rail-navi btn--rail__show'
                  onClick={() => {
                    this.naviStatus(true);
                  }}
                >
                  <i className='i-warrow-right i-2x' alt='開く' aria-hidden='true' />
                </div>
                <div
                  id='func-navi--item1-btn-close'
                  className='btn-rail-navi btn--rail__hide'
                  onClick={() => {
                    this.naviStatus(false);
                  }}
                >
                  <i className='i-warrow-left i-2x' alt='閉じる' aria-hidden='true' />
                </div>
              </div>
              <div className='rail__menu'>
                <div className='func-navi'>
                  <ul className='list list--func-navi'>
                    <h2 className='list__header'>機能一覧</h2>
                    <div className='list__scroll'>
                      <li className='list__item'>
                        <div
                          className={itemSelected('InOutDashboard')}
                          onClick={() => {
                            this.loadPage('InOutDashboard');
                          }}
                        >
                          <div className='icon icon--line-list'>
                            <i className='i-home' aria-hidden='true' />
                          </div>
                          ダッシュボード
                        </div>
                      </li>
                      <li className='list__item'>
                        <div
                          className={itemSelected('InOutResult')}
                          onClick={() => {
                            this.loadPage('InOutResult');
                          }}
                        >
                          <div className='icon icon--line-list'>
                            <i className='i-kadobi' aria-hidden='true' />
                          </div>
                          入退場実績
                        </div>
                      </li>
                      {!isPartnerCompanyRoleId(LocalStorageService.getRoleId()) && (
                        <React.Fragment>
                          <li className='list__item'>
                            <div
                              className={itemSelected('InOutHistoryUserUnregistered')}
                              onClick={() => {
                                this.loadPage('InOutHistoryUserUnregistered');
                              }}
                            >
                              <div className='icon icon--line-list'>
                                <i className='i-error' aria-hidden='true' />
                              </div>
                              不明な入退場データ
                            </div>
                          </li>
                          <li className='list__item'>
                            <div
                              className={itemSelected('FieldSettings')}
                              onClick={() => {
                                this.loadPage('FieldSettings');
                              }}
                            >
                              <div className='icon icon--line-list'>
                                <i className='i-settei' aria-hidden='true' />
                              </div>
                              現場設定
                            </div>
                          </li>
                        </React.Fragment>
                      )}
                      {!isTargetRoleId(
                        [USER_ROLES.foreman, USER_ROLES.operator, USER_ROLES.driver],
                        LocalStorageService.getRoleId()
                      ) && (
                        <React.Fragment>
                          <li className='list__item'>
                            <div
                              className={itemSelected('WorkerSettings')}
                              onClick={() => {
                                this.loadPage('WorkerSettings');
                              }}
                            >
                              <div className='icon icon--line-list'>
                                <i className='i-id' aria-hidden='true' />
                              </div>
                              作業員設定状況一覧
                            </div>
                          </li>
                        </React.Fragment>
                      )}
                      {this.state.spotFlg &&
                        !isPartnerCompanyRoleId(LocalStorageService.getRoleId()) && (
                          <React.Fragment>
                            <li className='list__item'>
                              <div
                                className={itemSelected('ResidentSpotWorkers')}
                                onClick={() => {
                                  this.loadPage('ResidentSpotWorkers');
                                }}
                              >
                                <div className='icon icon--line-list'>
                                  <i className='i-id' aria-hidden='true' />
                                </div>
                                現場常駐社員一覧
                              </div>
                            </li>
                            <li className='list__item'>
                              <div
                                className={itemSelected('NonResidentSpotWorkers')}
                                onClick={() => {
                                  this.loadPage('NonResidentSpotWorkers');
                                }}
                              >
                                <div className='icon icon--line-list'>
                                  <i className='i-id' aria-hidden='true' />
                                </div>
                                非常駐入退場者一覧
                              </div>
                            </li>
                          </React.Fragment>
                        )}
                      {/* 共通メニュー */}
                      <FieldBulletinBoardMenuList
                        itemSelected={itemSelected('fieldBulletinBoard')}
                        src={'entry'}
                      />
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          );
        }}
      </PermissionConsumer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/enterFuncNavi.js